import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { IconWrapper } from '../IconWrapper/IconWrapper.js';
import '../../../tslib.es6-a39f91fc.js';
import '../../../index-6ea95111.js';
import '../../../style-inject.es-1f59c1d0.js';

var Smartphone = (function (props) {
    return createElement(IconWrapper, props, jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6.75 22h10.5c.966 0 1.75-.895 1.75-2V4c0-1.105-.784-2-1.75-2H6.75C5.784 2 5 2.895 5 4v16c0 1.105.784 2 1.75 2Z" }), jsx("path", { stroke: "currentColor", strokeDasharray: "0 1000000", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 2.413, strokeWidth: 2, d: "M12 18.041v-.04" }));
});

export default Smartphone;
//# sourceMappingURL=Smartphone.js.map
